/**
 * @name applyClass
 *
 * @description Adds or removes a class from an element
 *
 * @example
 * import { applyClass } from '@workbench/core';
 *
 * applyClass(document.body, 'scroll-lock', true); // adds class .scroll-lock
 * applyClass(document.body, 'scroll-lock', false); // removes class .scroll-lock
 */
export const applyClass = (el: HTMLElement, className: string, value: boolean): void => {
  if (value) {
    el.classList.add(className);
  } else {
    el.classList.remove(className);
  }
};
